import {dataManipulator, entityDataManager} from "@/assets/js/data-manipulation";
import i18n from "@/assets/js/vue/i18n";

export const popups= {
    yesNoConfirmation(swal, title) {
        return swal.fire({
            title,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: i18n.global.t('generic.yes'),
            cancelButtonText: i18n.global.t('generic.no')
        });
    },
    information(swal, title, description) {
        return swal.fire({
            title,
            text: description,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: i18n.global.t('generic.close')
        });
    },
    showViolationsSourceInfo(swal, company, licensePlate = null) {
        const text = `<div class="px-20">${entityDataManager.getViolationsInfoHtml(company, licensePlate)}</div>`;

        swal.fire({
            html: text,
            width: 'fit-content',
            showCloseButton: true,
            showConfirmButton: false,
            showCancelButton: false
        })
    },
    showViolations(swal, violations, vehicles, company, licensePlate = null) {
        let text = entityDataManager.getViolationsInfoHtml(company, licensePlate);

        text += '<div class="data-grid table-pad table-pad-popup sticky-h-700 max-h-85vh">';
        text += '<table class="table-tracking">';
        text += '<thead><tr>';
        text += `<th>${i18n.global.t('reports.violations.table-header.name')}</th>`;
        text += `<th>${i18n.global.t('settings.car-fleet.form.vehicle-license-plate')}</th>`;
        text += `<th>${i18n.global.t('reports.violations.table-header.violation-number')}</th>`;
        text += `<th>${i18n.global.t('generic.date')}</th>`;
        text += `<th>${i18n.global.t('generic.amount')}</th>`;
        text += `<th>${i18n.global.t('reports.violations.table-header.reason')}</th>`;
        text += `<th>${i18n.global.t('reports.violations.table-header.source')}</th>`;
        text += '</tr></thead>';
        text += '<tbody>';
        for (const violation of violations) {
            const vehicle = entityDataManager.getVehicleByLicensePlate(vehicles, violation.licensePlate, item => dataManipulator.formatLicensePlateToEnglishChars(item));
            text += '<tr>';
            text += `<td>${vehicle?.nickname ?? ''}</td>`;
            text += `<td>${violation.licensePlate}</td>`;
            text += `<td>${violation.violationNumber}</td>`;
            text += `<td>${dataManipulator.dateToString(new Date(violation.violationDate))}</td>`;
            text += `<td>${violation.amount}</td>`;
            text += `<td>${violation.violationReason}</td>`;
            text += `<td>${i18n.global.t(`reports.violations.table-header.${violation.source}`)}</td>`;
            text += '</tr>';
        }
        text += '</tbody>';
        text += '</table>'
        text += '<div>';

        swal.fire({
            html: text,
            width: 'fit-content',
            showCloseButton: true,
            showConfirmButton: false,
            showCancelButton: false
        })
    }
}